import React from 'react'
import ReactDOM from 'react-dom';
import './index.css';
import { ThemeProvider } from 'react-ui'
import { tokens, components } from 'react-ui/themes/light'
import App from './App';
import reportWebVitals from './reportWebVitals';
import config, { environment } from './config';
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";
import { BrowserRouter } from 'react-router-dom';

if (process.env.NODE_ENV !== 'test') {
ReactDOM.render(
  <React.StrictMode>
            <ThemeProvider tokens={tokens} components={components}>
                <GoogleReCaptchaProvider reCaptchaKey={process.env.REACT_APP_SZNO_APP_RECAPTCHA_SITE_KEY}>
                    <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
                        <App />
                    </BrowserRouter>
                </GoogleReCaptchaProvider>
            </ThemeProvider>
  </React.StrictMode>,
  document.getElementById('root')
);
}
reportWebVitals();

export { config, environment };